import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"margin":"1rem 2rem"} }
const _hoisted_2 = { style: {"padding":"0.5rem 0","line-height":"1.2"} }

import { IonAlert, IonLoading, IonButton, IonItem } from '@ionic/vue';
import router from '@/router';
import { MobileApi, Configuration } from 'plate-vision-demo-openapi-client/dist';
import { onMounted, onUnmounted, ref } from 'vue';
import { Storage } from '@ionic/storage';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'EmailConfirm',
  setup(__props) {

const { t } = useI18n({
      inheritLocale: true,
      useScope: 'global'
})


const storage = new Storage();
let mobileApi: MobileApi;

onMounted(()=> {
    storage.create();
    storage.get('token').then((token: string) => {
        mobileApi = new MobileApi(new Configuration({accessToken: token, basePath: process.env.VUE_APP_PATH}));
    })
});

function confirmEmail(){
    isLoading.value = true;
    mobileApi.getCredits().then(() => {
        storage.set('emailConfirmed', 1).then(() => {
            router.push({name: 'startGuide'});
        })
    }).catch((error) => {
        isLoading.value = false;
        showErrorConnection.value = true;
        console.log(error);
    })
}

const showErrorConnection = ref(false);
const isLoading = ref(false);

onUnmounted(() => {
    isLoading.value = false;
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonAlert), {
      "is-open": showErrorConnection.value,
      header: _unref(t)('emailConfirmation.alertHeader'),
      subHeader: _unref(t)('emailConfirmation.alertSubHeader'),
      buttons: ['OK'],
      onDidDismiss: _cache[0] || (_cache[0] = ($event: any) => (showErrorConnection.value = false))
    }, null, 8, ["is-open", "header", "subHeader"]),
    _createElementVNode("h4", _hoisted_1, _toDisplayString(_unref(t)('emailConfirmation.title')), 1),
    _createVNode(_unref(IonItem), { class: "margin-1-rem-tb bradius12" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", null, _toDisplayString(_unref(t)('emailConfirmation.p1')), 1),
          _createElementVNode("p", null, _toDisplayString(_unref(t)('emailConfirmation.p2')), 1)
        ])
      ]),
      _: 1
    }),
    _createVNode(_unref(IonButton), {
      id: "confirmEmail",
      class: "max-width-button",
      shape: "round",
      size: "large",
      expand: "block",
      onClick: confirmEmail
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('continue')), 1)
      ]),
      _: 1
    }),
    _createVNode(_unref(IonLoading), {
      "is-open": isLoading.value,
      message: _unref(t)('emailConfirmation.confirming')
    }, null, 8, ["is-open", "message"])
  ], 64))
}
}

})